<template>
    <Page
        v-if="page"
        class="page"
        :page="page"
    />
</template>

<script>
import Page from '~/components/pages/Page';
import PageInstagramFeed from '~/components/PageInstagramFeed';

export default {

    components: {
        Page,
        PageInstagramFeed,
    },

    async asyncData({ route, store, error }) {
        const page = await store.dispatch('content/getPage', route.params.slug);

        if (page) {
            return {
                page,
            };
        }

        error({ statusCode: 404 });
    },

    head() {
        return {
            title: this.page?.meta_title || this.page?.title,
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.page?.meta_description,
                },
                {
                    hid: 'og:title',
                    name: 'og:title',
                    content: this.page?.meta_title,
                },
            ],
        };
    },

};
</script>

<style>
</style>
